<mat-dialog-content class="demo-toggle-dialogue-container">
  <div fxLayoutAlign="end center">
    <button mat-flat-button class="demo-toggle-dialog-x" (click)="close()">
      X
    </button>
  </div>
  <div class="demo-toggle-dual-bubbles"><img [src]="bubbleSvg" /></div>
  <div class="demo-toggle-dialogue-title">
    Hello, {{data.userProfile.fullName}}
  </div>
  <p class="demo-toggle-dialogue-subtext">
    Before continuing, please select a class from the list below.
  </p>
  <div class="demo-toggle-dialogue-class-list-header">Select a Class</div>
  <div class="demo-toggle-radio-container">
    <mat-radio-group
      aria-label="Select an option"
      [(ngModel)]="selectedCourse"
      >
      @for (course of data.courses; track course) {
        <mat-radio-button
          class="demo-toggle-radio-button"
          value="{{course.courseID}}"
          [disabled]="!course.students || !course.students?.length"
          >
          {{course.courseTitle}}{{(course.students?.length) ? "" : " (no students)"}}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedCourse"
    (click)="continue()"
    >
    Continue
  </button>
</mat-dialog-actions>
